import { Box, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AUTH_LAYOUT_LOGO } from '../constants/brand';
import { CommonLayoutProps } from './types';

export type LogoSize = 'large' | 'medium' | 'small';

interface AppLogoLayoutProps extends CommonLayoutProps {
  logoSize: LogoSize;
}

const logoSizeMap: Record<LogoSize, number> = {
  large: 300,
  medium: 225,
  small: 200,
};

const logoPaddingMap: Record<LogoSize, number> = {
  large: 4,
  medium: 3,
  small: 2.5,
};

export default function AppLogoLayout({
  children,
  logoSize,
}: AppLogoLayoutProps) {
  const navigate = useNavigate();

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        pb: 4.5,
        pt: 4.5,
        minHeight: '100dvh',
      }}
    >
      <Box
        alignSelf="center"
        justifySelf="center"
        width={`${logoSizeMap[logoSize]}px`}
        maxWidth="70%"
        py={logoPaddingMap[logoSize]}
        onClick={() => navigate('/')}
        sx={{ cursor: 'pointer' }}
      >
        <img src={AUTH_LAYOUT_LOGO} alt="Pari Logo" width="100%" className="" />
      </Box>
      {children}
    </Container>
  );
}
